uvex-article-detail {
  display: block;

  .ce-headline {
    margin-bottom: 0;
  }

  uvex-youtube-video + uvex-youtube-video {
    margin-top: 1.5rem;
  }
}
